import CampanaNotificaciones from "./CampanaNotificaciones";
import BotonInstructivo from "./BotonInstructivo";
import BotonMapaProceso from "./BotonMapaProceso";
import { useState } from "react";
import { subirDatos, eliminarDato } from "./syncSupabase";

const STORAGE_DSP = 'alqos_despachos';
const STORAGE_OTS = 'alqos_ots';
const STORAGE_FSC = 'alqos_fsc_arqueo';


const storage = {
  get: (k) => { try { return JSON.parse(localStorage.getItem(k)||'[]'); } catch { return []; } },
  set: (k,v) => { try { localStorage.setItem(k,JSON.stringify(v)); return true; } catch { return false; } },
};

function genCod(lista, pre) {
  return `${pre}-${new Date().getFullYear()}-${String(lista.length+1).padStart(4,'0')}`;
}
function fechaHoy() { return new Date().toISOString().slice(0,10); }
function mesActual() { return new Date().toISOString().slice(0,7); }

export default function Despacho({ onVolver, oscuro, usuario }) {
  const [despachos, setDespachos] = useState(() => storage.get(STORAGE_DSP));
  const [ots,       setOts]       = useState(() => storage.get(STORAGE_OTS));
  const [seccion,   setSeccion]   = useState('despachos');
  const [vista,     setVista]     = useState('listado');
  const [form,      setForm]      = useState({ fecha: fechaHoy(), fscMaterial: false });
  const [detalle,   setDetalle]   = useState(null);
  const [confirm,   setConfirm]   = useState(null);
  const [filtroMes, setFiltroMes] = useState(mesActual());
  const [toast,     setToast]     = useState(null);

  const bg     = oscuro ? '#09184D' : '#F0EEFF';
  const cardBg = oscuro ? '#0d2160' : 'white';
  const texto  = oscuro ? '#EDF2FA' : '#2F3E2E';
  const borde  = oscuro ? '#1e3a8a' : '#eee';
  const navBg  = oscuro ? '#060f30' : '#09184D';
  const sub    = oscuro ? '#9aabd4' : '#808085';
  const esAdmin = ['Administrador','Calidad'].includes(usuario?.rol);

  const inp = { width:'100%', padding:'8px 12px', borderRadius:'8px', border:`1px solid ${borde}`, fontSize:'13px', boxSizing:'border-box', marginTop:'4px', background:cardBg, color:texto, fontFamily:'sans-serif', outline:'none' };
  const lbl = { fontSize:'11px', color:sub, fontWeight:'700', display:'block', marginTop:'12px', textTransform:'uppercase', letterSpacing:'.05em' };
  const card = { background:cardBg, borderRadius:'14px', padding:'1.5rem', border:`1px solid ${borde}`, marginBottom:'14px' };

  const mostrarToast = (msg) => { setToast(msg); setTimeout(() => setToast(null), 3000); };

  const otsAprobadas = ots.filter(o => o.estado === 'aprobado');

  const guardar = () => {
    if (!form.otVinculada) { alert('Seleccioná una OT aprobada'); return; }
    if (!form.destinatario?.trim()) { alert('Ingresá el destinatario'); return; }

    const ot = ots.find(o => o.op === form.otVinculada);
    const existentes = storage.get(STORAGE_DSP);
    const codigo = genCod(existentes, 'DSP');
    const remito = genCod(existentes, 'REM');

    const nuevo = {
      id: Date.now(),
      codigo,
      remito,
      otVinculada: form.otVinculada,
      cliente: ot?.cliente || form.destinatario,
      destinatario: form.destinatario,
      direccion: form.direccion || '',
      cantidad: form.cantidad || ot?.cantidad || '',
      unidad: form.unidad || ot?.unidad || '',
      producto: form.producto || ot?.trabajo || '',
      cotizacionRef: form.cotizacionRef || ot?.cotizacionRef || '',
      transportista: form.transportista || '',
      observaciones: form.observaciones || '',
      fscMaterial: form.fscMaterial,
      fecha: form.fecha,
      fechaCreacion: new Date().toISOString(),
      creadoPor: usuario?.nombre || 'Sistema',
      estado: 'despachado',
    };

    // Guardar despacho
    const nuevos = [...existentes, nuevo];
    storage.set(STORAGE_DSP, nuevos);
    subirDatos(STORAGE_DSP);
    setDespachos(nuevos);

    // Cerrar OT → entregado
    const otsAct = ots.map(o => o.op === form.otVinculada
      ? { ...o, estado: 'entregado', fechaEntrega: form.fecha, cambiadoPor: usuario?.nombre, ultimoCambio: new Date().toISOString() }
      : o
    );
    storage.set(STORAGE_OTS, otsAct);
    subirDatos(STORAGE_OTS);
    setOts(otsAct);

    // Registrar salida FSC si aplica
    if (form.fscMaterial) {
      const fsc = storage.get(STORAGE_FSC);
      const movFSC = {
        id: Date.now() + 1,
        idMovimiento: genCod(fsc, 'FSC'),
        tipoMovimiento: 'SALIDA',
        origen: 'Producción',
        certificadoFSC: 'FSC 100%',
        producto: nuevo.producto || 'Material certificado',
        descripcion: `Salida por despacho ${codigo} — OT: ${form.otVinculada}`,
        ot: form.otVinculada,
        kgEntrada: 0,
        kgSalida: parseFloat(form.kgFSC || 0),
        kgScrap: 0,
        fecha: form.fecha,
        fechaRegistro: new Date().toISOString(),
        creadoPor: usuario?.nombre || 'Sistema',
        _generadoDesde: 'despacho',
        _source: 'localStorage',
      };
      storage.set(STORAGE_FSC, [...fsc, movFSC]);
      subirDatos(STORAGE_FSC);
    }

    setForm({ fecha: fechaHoy(), fscMaterial: false });
    setVista('listado');
    mostrarToast(`✅ Despacho ${codigo} generado · Remito ${remito} · OT cerrada`);
  };

  const eliminar = async (id) => {
    const nuevos = despachos.filter(d => d.id !== id);
    storage.set(STORAGE_DSP, nuevos);
    await eliminarDato(STORAGE_DSP, id);
    setDespachos(nuevos);
    setConfirm(null); setDetalle(null); setVista('listado');
  };

  const exportarRemito = (d) => {
    const fecha = new Date(d.fecha).toLocaleDateString('es-AR');
    const html = `<!DOCTYPE html>
<html lang="es">
<head><meta charset="utf-8"><title>Remito ${d.remito}</title>
<style>
* { margin:0; padding:0; box-sizing:border-box; }
body { font-family:Arial,sans-serif; font-size:11px; color:#2B2F36; padding:32px; }
.header { display:flex; justify-content:space-between; align-items:flex-start; margin-bottom:24px; border-bottom:2px solid #1C3FAA; padding-bottom:16px; }
.logo { font-size:24px; font-weight:800; color:#1C3FAA; letter-spacing:.15em; }
.logo span { font-size:11px; color:#2A7FFF; }
.remito-num { font-size:20px; font-weight:700; color:#1C3FAA; text-align:right; }
.remito-fecha { font-size:11px; color:#808085; text-align:right; }
.section { margin-bottom:16px; }
.section h3 { font-size:9px; font-weight:700; color:#808085; text-transform:uppercase; letter-spacing:.12em; margin-bottom:8px; }
.row { display:flex; justify-content:space-between; padding:5px 0; border-bottom:.5px solid #eee; font-size:11px; }
.row span:first-child { color:#808085; }
.row span:last-child { font-weight:600; color:#2B2F36; }
.total-box { background:#F0EEFF; border:2px solid #1C3FAA; border-radius:8px; padding:12px 16px; margin-top:16px; display:flex; justify-content:space-between; }
.total-box span:first-child { font-size:11px; font-weight:600; color:#1C3FAA; }
.total-box span:last-child { font-size:16px; font-weight:800; color:#1C3FAA; }
.fsc-badge { background:#f0fdf4; border:1px solid #22c55e; border-radius:6px; padding:6px 12px; font-size:10px; color:#15803d; font-weight:700; margin-top:8px; display:inline-block; }
.firma { margin-top:40px; display:flex; justify-content:space-between; }
.firma-box { text-align:center; width:180px; }
.firma-linea { border-top:1px solid #2B2F36; padding-top:6px; font-size:9px; color:#808085; }
.footer { margin-top:32px; text-align:center; font-size:9px; color:#ccc; letter-spacing:.1em; }
</style>
</head>
<body>
<div class="header">
  <div><div class="logo">ALQOS<span>™</span></div><div style="font-size:9px;color:#808085;margin-top:2px">by QORVEX · Sistema de Gestión Integral</div></div>
  <div><div class="remito-num">REMITO ${d.remito}</div><div class="remito-fecha">${fecha}</div></div>
</div>
<div class="section">
  <h3>Destinatario</h3>
  <div class="row"><span>Cliente</span><span>${d.cliente||'—'}</span></div>
  <div class="row"><span>Destinatario</span><span>${d.destinatario||'—'}</span></div>
  ${d.direccion?`<div class="row"><span>Dirección</span><span>${d.direccion}</span></div>`:''}
</div>
<div class="section">
  <h3>Detalle del despacho</h3>
  <div class="row"><span>Código despacho</span><span>${d.codigo}</span></div>
  <div class="row"><span>OT vinculada</span><span>${d.otVinculada||'—'}</span></div>
  <div class="row"><span>Producto / Trabajo</span><span>${d.producto||'—'}</span></div>
  <div class="row"><span>Cantidad</span><span>${d.cantidad||'—'} ${d.unidad||''}</span></div>
  ${d.cotizacionRef?`<div class="row"><span>Ref. cotización</span><span>${d.cotizacionRef}</span></div>`:''}
  ${d.transportista?`<div class="row"><span>Transportista</span><span>${d.transportista}</span></div>`:''}
  ${d.observaciones?`<div class="row"><span>Observaciones</span><span>${d.observaciones}</span></div>`:''}
</div>
${d.fscMaterial ? '<div class="fsc-badge">🌿 Material con certificación FSC Chain of Custody</div>' : ''}
<div class="firma">
  <div class="firma-box"><div class="firma-linea">Preparado por</div></div>
  <div class="firma-box"><div class="firma-linea">Recibido por</div></div>
  <div class="firma-box"><div class="firma-linea">Transportista</div></div>
</div>
<div class="footer">ALQOS™ · SISTEMA DE GESTIÓN INTEGRAL · by QORVEX · CONFIDENCIAL</div>
</body></html>`;
    const w = window.open('','_blank');
    w.document.write(html);
    w.document.close();
    setTimeout(() => w.print(), 500);
  };

  const exportarFactura = (d) => {
    const fecha = new Date(d.fecha).toLocaleDateString('es-AR');
    const nroFactura = d.remito.replace('REM','FAC');
    const html = `<!DOCTYPE html><html lang="es"><head><meta charset="utf-8"><title>Factura</title>
<style>*{margin:0;padding:0;box-sizing:border-box}body{font-family:Arial,sans-serif;font-size:11px;color:#2B2F36;padding:32px}.header{display:flex;justify-content:space-between;margin-bottom:24px;border-bottom:3px solid #1C3FAA;padding-bottom:16px}.logo{font-size:22px;font-weight:800;color:#1C3FAA}.fact-num{font-size:20px;font-weight:800;color:#1C3FAA;text-align:right}.row{display:flex;justify-content:space-between;padding:5px 0;border-bottom:.5px solid #f5f5f5;font-size:11px}.row span:first-child{color:#808085}.row span:last-child{font-weight:600}table{width:100%;border-collapse:collapse;margin-top:8px}th{background:#1C3FAA;color:white;padding:7px 10px;font-size:10px;text-align:left}td{padding:8px 10px;border-bottom:1px solid #eee;font-size:11px}.total-final{display:flex;justify-content:space-between;padding:10px 14px;background:#1C3FAA;color:white;border-radius:8px;margin-top:12px;font-size:14px;font-weight:800}.firma{margin-top:40px;display:flex;justify-content:space-between}.firma-box{text-align:center;width:160px}.firma-linea{border-top:1px solid #2B2F36;padding-top:6px;font-size:9px;color:#808085}.footer{margin-top:24px;text-align:center;font-size:9px;color:#ccc;border-top:1px solid #eee;padding-top:10px}h3{font-size:9px;font-weight:700;color:#808085;text-transform:uppercase;letter-spacing:.12em;margin:14px 0 8px;border-bottom:1px solid #eee;padding-bottom:4px}</style>
</head><body>
<div class="header">
  <div><div class="logo">ALQOS™</div><div style="font-size:9px;color:#808085;margin-top:4px">by QORVEX · Sistema de Gestión Integral</div>
  <div style="font-size:10px;font-weight:600;margin-top:8px">Razón Social de la Empresa</div>
  <div style="font-size:9px;color:#808085">CUIT: XX-XXXXXXXX-X · IVA Responsable Inscripto</div></div>
  <div><div class="fact-num">FACTURA ${nroFactura}</div>
  <div style="font-size:11px;color:#808085;text-align:right">Tipo B · ${fecha}</div>
  <div style="font-size:9px;color:#808085;text-align:right;margin-top:4px">Remito: ${d.remito}</div></div>
</div>
<h3>Datos del cliente</h3>
<div class="row"><span>Cliente</span><span>${d.cliente||'—'}</span></div>
<div class="row"><span>Destinatario</span><span>${d.destinatario||'—'}</span></div>
${d.direccion ? '<div class="row"><span>Dirección</span><span>' + d.direccion + '</span></div>' : ''}
<h3>Detalle</h3>
<table><tr><th>Descripción</th><th>Cantidad</th><th>Unidad</th><th>Precio unit.</th><th>Total</th></tr>
<tr><td>${d.producto||'Trabajo gráfico'}</td><td>${d.cantidad||'1'}</td><td>${d.unidad||'u.'}</td><td>—</td><td>—</td></tr>
</table>
<div style="margin-top:16px;border-top:2px solid #1C3FAA;padding-top:12px">
  <div class="row"><span>Subtotal</span><span>—</span></div>
  <div class="row"><span>IVA 21%</span><span>—</span></div>
  <div class="total-final"><span>TOTAL</span><span>—</span></div>
</div>
<div style="margin-top:10px;padding:8px 12px;background:#F0EEFF;border-radius:6px;font-size:11px;color:#1C3FAA;font-weight:600">
  Condición de pago: Contado · OT: ${d.otVinculada||'—'} · Ref: ${d.cotizacionRef||'—'}
</div>
${d.fscMaterial?'<div style="margin-top:8px;padding:6px 12px;background:#f0fdf4;border:1px solid #22c55e;border-radius:6px;font-size:10px;color:#15803d;font-weight:700">🌿 Material FSC certificado</div>':''}
<div class="firma">
  <div class="firma-box"><div class="firma-linea">Firma y aclaración</div></div>
  <div class="firma-box"><div class="firma-linea">Recibí conforme</div></div>
</div>
<div class="footer">ALQOS™ · DOCUMENTO NO VÁLIDO COMO FACTURA FISCAL</div>
</body></html>`;
    const w = window.open('','_blank');
    w.document.write(html);
    w.document.close();
    setTimeout(() => w.print(), 500);
  };

  const despachosMes = despachos.filter(d => d.fecha?.startsWith(filtroMes));
  const resumen = {
    total: despachos.length,
    mes: despachosMes.length,
    fsc: despachos.filter(d => d.fscMaterial).length,
    clientes: [...new Set(despachos.map(d => d.cliente).filter(Boolean))].length,
  };

  // ── CONFIRM ELIMINAR ──
  if (confirm) return (
    <div style={{ minHeight:'100vh', background:bg, fontFamily:'sans-serif', display:'flex', alignItems:'center', justifyContent:'center' }}>
      <div style={{ background:cardBg, borderRadius:'16px', padding:'2rem', maxWidth:'360px', width:'90%', border:`1px solid ${borde}`, textAlign:'center' }}>
        <p style={{ fontSize:'36px' }}>📦</p>
        <p style={{ fontSize:'15px', fontWeight:'600', color:texto, marginBottom:'.5rem' }}>¿Eliminar este despacho?</p>
        <p style={{ fontSize:'13px', color:sub, marginBottom:'1.5rem' }}>Esta acción no se puede deshacer.</p>
        <div style={{ display:'flex', gap:'10px', justifyContent:'center' }}>
          <button onClick={() => setConfirm(null)} style={{ padding:'10px 20px', background:'none', border:`1px solid ${borde}`, borderRadius:'10px', cursor:'pointer', color:texto, fontSize:'13px' }}>Cancelar</button>
          <button onClick={() => eliminar(confirm)} style={{ padding:'10px 20px', background:'#e63946', border:'none', borderRadius:'10px', cursor:'pointer', color:'white', fontSize:'13px', fontWeight:'600' }}>Eliminar</button>
        </div>
      </div>
    </div>
  );

  // ── DETALLE ──
  if (vista === 'detalle' && detalle) return (
    <div style={{ minHeight:'100vh', background:bg, fontFamily:'sans-serif' }}>
      <div style={{ background:navBg, padding:'1rem 1.5rem', display:'flex', alignItems:'center', justifyContent:'space-between', position:'sticky', top:0, zIndex:100, marginBottom:'1.5rem' }}>
        <div style={{ display:'flex', alignItems:'center', gap:'12px' }}>
          <button onClick={() => { setDetalle(null); setVista('listado'); }} style={{ background:'rgba(255,255,255,0.1)', border:'none', color:'white', padding:'6px 14px', borderRadius:'10px', cursor:'pointer', fontSize:'13px' }}>← Volver</button>
          <span style={{ color:'white', fontWeight:'700', fontSize:'16px' }}>{detalle.codigo}</span>
        </div>
        <div style={{ display:'flex', gap:'8px' }}>
          <button onClick={() => exportarRemito(detalle)} style={{ padding:'6px 14px', background:'linear-gradient(135deg,#22c55e,#15803d)', border:'none', borderRadius:'8px', cursor:'pointer', color:'white', fontSize:'12px', fontWeight:'700' }}>🖨️ Imprimir remito</button>
          <button onClick={() => exportarFactura(detalle)} style={{ padding:'6px 14px', background:'linear-gradient(135deg,#1C3FAA,#2A7FFF)', border:'none', borderRadius:'8px', cursor:'pointer', color:'white', fontSize:'12px', fontWeight:'700' }}>🧾 Factura</button>
          {esAdmin && <button onClick={() => setConfirm(detalle.id)} style={{ background:'rgba(230,57,70,.2)', border:'1px solid rgba(230,57,70,.4)', color:'#e63946', padding:'6px 14px', borderRadius:'10px', cursor:'pointer', fontSize:'12px' }}>🗑 Eliminar</button>}
        </div>
      </div>
      <div style={{ padding:'0 2rem 2rem', maxWidth:'700px', margin:'0 auto' }}>
        <div style={{ ...card, background:oscuro?'#0a1f5c':'#eff6ff', border:`1px solid #2A7FFF30` }}>
          <h3 style={{ fontSize:'13px', fontWeight:'700', color:'#2A7FFF', marginBottom:'12px', textTransform:'uppercase' }}>Remito {detalle.remito}</h3>
          {[['Código despacho',detalle.codigo],['OT vinculada',detalle.otVinculada],['Cliente',detalle.cliente],['Destinatario',detalle.destinatario],['Dirección',detalle.direccion],['Producto',detalle.producto],['Cantidad',detalle.cantidad?`${detalle.cantidad} ${detalle.unidad||''}`:null],['Cotización ref.',detalle.cotizacionRef],['Transportista',detalle.transportista],['Fecha despacho',detalle.fecha],['Creado por',detalle.creadoPor]].map(([k,v])=>v&&(
            <div key={k} style={{ display:'flex', justifyContent:'space-between', fontSize:'13px', padding:'5px 0', borderBottom:`0.5px solid ${borde}` }}>
              <span style={{ color:sub }}>{k}</span>
              <span style={{ color:texto, fontWeight:'500' }}>{v}</span>
            </div>
          ))}
          {detalle.fscMaterial && <div style={{ marginTop:'10px', padding:'6px 12px', background:'#f0fdf4', border:'1px solid #22c55e', borderRadius:'8px', fontSize:'12px', color:'#15803d', fontWeight:'700' }}>🌿 Material FSC certificado — salida registrada en arqueo</div>}
        </div>
        {detalle.observaciones && (
          <div style={card}>
            <h3 style={{ fontSize:'13px', fontWeight:'700', color:texto, marginBottom:'8px' }}>Observaciones</h3>
            <p style={{ fontSize:'13px', color:texto, margin:0, lineHeight:'1.6' }}>{detalle.observaciones}</p>
          </div>
        )}
      </div>
    </div>
  );

  // ── NUEVO DESPACHO ──
  if (vista === 'nueva') return (
    <div style={{ minHeight:'100vh', background:bg, fontFamily:'sans-serif' }}>
      <div style={{ background:navBg, padding:'1rem 1.5rem', display:'flex', alignItems:'center', justifyContent:'space-between', position:'sticky', top:0, zIndex:100, marginBottom:'1.5rem' }}>
        <div style={{ display:'flex', alignItems:'center', gap:'12px' }}>
          <button onClick={() => setVista('listado')} style={{ background:'rgba(255,255,255,0.1)', border:'none', color:'white', padding:'6px 14px', borderRadius:'10px', cursor:'pointer', fontSize:'13px' }}>← Volver</button>
          <span style={{ color:'white', fontWeight:'700', fontSize:'16px' }}>Nuevo Despacho</span>
        </div>
      </div>
      <div style={{ padding:'0 2rem 2rem', maxWidth:'700px', margin:'0 auto' }}>
        <div style={{ ...card, background:oscuro?'#0a1f5c':'#eff6ff', border:`1px solid #2A7FFF30` }}>
          <p style={{ fontSize:'12px', color:sub, margin:0 }}>Creado por: <strong style={{ color:texto }}>{usuario?.nombre}</strong> — {usuario?.rol}</p>
        </div>

        <div style={card}>
          <h3 style={{ fontSize:'14px', fontWeight:'700', color:'#09184D', marginBottom:'12px' }}>OT a despachar</h3>
          {otsAprobadas.length === 0
            ? <div style={{ padding:'1rem', background:oscuro?'#1a0a00':'#fffbeb', border:'1px solid #f59e0b', borderRadius:'10px', fontSize:'13px', color:'#92400e' }}>
                ⚠️ No hay OTs en estado "Aprobado". Cambiá el estado de la OT antes de despachar.
              </div>
            : <>
                <span style={lbl}>Seleccioná la OT *</span>
                <select value={form.otVinculada||''} onChange={e => {
                  const ot = ots.find(o => o.op === e.target.value);
                  setForm(f => ({ ...f, otVinculada: e.target.value, cliente: ot?.cliente||'', producto: ot?.trabajo||'', cantidad: ot?.cantidad||'', unidad: ot?.unidad||'', cotizacionRef: ot?.cotizacionRef||'' }));
                }} style={inp}>
                  <option value=''>— Seleccioná una OT —</option>
                  {otsAprobadas.map(o => <option key={o.op} value={o.op}>{o.op} · {o.cliente} · {o.trabajo?.slice(0,30)}</option>)}
                </select>
                {form.otVinculada && (
                  <div style={{ marginTop:'8px', padding:'8px 12px', background:oscuro?'#0a1f5c':'#f0fff4', border:'1px solid #22c55e', borderRadius:'8px', fontSize:'12px', color:'#15803d' }}>
                    ✅ Al guardar, la OT pasará a estado <strong>Entregado</strong>
                  </div>
                )}
              </>
          }
        </div>

        <div style={card}>
          <h3 style={{ fontSize:'14px', fontWeight:'700', color:'#09184D', marginBottom:'12px' }}>Datos del despacho</h3>
          <span style={lbl}>Fecha de despacho *</span>
          <input type='date' value={form.fecha} onChange={e => setForm(f=>({...f,fecha:e.target.value}))} style={inp}/>
          <span style={lbl}>Destinatario *</span>
          <input value={form.destinatario||''} onChange={e => setForm(f=>({...f,destinatario:e.target.value}))} style={inp} placeholder='Nombre del destinatario'/>
          <span style={lbl}>Dirección de entrega</span>
          <input value={form.direccion||''} onChange={e => setForm(f=>({...f,direccion:e.target.value}))} style={inp} placeholder='Calle, número, localidad'/>
          <span style={lbl}>Producto / Descripción</span>
          <input value={form.producto||''} onChange={e => setForm(f=>({...f,producto:e.target.value}))} style={inp} placeholder='Se autocompleta desde la OT'/>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px' }}>
            <div>
              <span style={lbl}>Cantidad</span>
              <input type='number' value={form.cantidad||''} onChange={e => setForm(f=>({...f,cantidad:e.target.value}))} style={inp}/>
            </div>
            <div>
              <span style={lbl}>Unidad</span>
              <input value={form.unidad||''} onChange={e => setForm(f=>({...f,unidad:e.target.value}))} style={inp} placeholder='estuches, u., kg'/>
            </div>
          </div>
          <span style={lbl}>Transportista</span>
          <input value={form.transportista||''} onChange={e => setForm(f=>({...f,transportista:e.target.value}))} style={inp} placeholder='Nombre del transportista'/>
          <span style={lbl}>Referencia cotización</span>
          <input value={form.cotizacionRef||''} onChange={e => setForm(f=>({...f,cotizacionRef:e.target.value}))} style={inp} placeholder='COT-2026-XXXX'/>
          <span style={lbl}>Observaciones</span>
          <textarea rows={2} value={form.observaciones||''} onChange={e => setForm(f=>({...f,observaciones:e.target.value}))} style={{ ...inp, resize:'none' }}/>
        </div>

        <div style={{ ...card, background:oscuro?'#0d3d2e':'#f0fff4', border:'1px solid #22c55e40' }}>
          <h3 style={{ fontSize:'14px', fontWeight:'700', color:'#15803d', marginBottom:'12px' }}>🌿 Trazabilidad FSC</h3>
          <label style={{ display:'flex', alignItems:'center', gap:'10px', cursor:'pointer', fontSize:'13px', color:texto }}>
            <input type='checkbox' checked={form.fscMaterial} onChange={e => setForm(f=>({...f,fscMaterial:e.target.checked}))} style={{ width:'16px', height:'16px' }}/>
            Material con certificación FSC — registrar salida en arqueo
          </label>
          {form.fscMaterial && (
            <>
              <span style={lbl}>Kg despachados (FSC)</span>
              <input type='number' value={form.kgFSC||''} onChange={e => setForm(f=>({...f,kgFSC:e.target.value}))} style={inp} placeholder='0.00'/>
            </>
          )}
        </div>

        <button onClick={guardar} style={{ width:'100%', padding:'15px', background:'linear-gradient(135deg,#2A7FFF,#09184D)', color:'white', border:'none', borderRadius:'12px', fontSize:'15px', fontWeight:'700', cursor:'pointer', marginTop:'.5rem' }}>
          📦 Registrar despacho
        </button>
      </div>
    </div>
  );

  // ── LISTADO PRINCIPAL ──
  return (
    <div style={{ minHeight:'100vh', background:bg, fontFamily:'sans-serif' }}>
      {toast && (
        <div style={{ position:'fixed', top:'20px', left:'50%', transform:'translateX(-50%)', background:'#09184D', color:'white', padding:'10px 20px', borderRadius:'12px', fontSize:'13px', fontWeight:'600', zIndex:2000, boxShadow:'0 4px 20px rgba(9,24,77,0.3)', border:'1px solid rgba(42,127,255,0.4)' }}>
          {toast}
        </div>
      )}

      <div style={{ background:navBg, padding:'1rem 1.5rem', display:'flex', alignItems:'center', justifyContent:'space-between', position:'sticky', top:0, zIndex:100 }}>
        <div style={{ display:'flex', alignItems:'center', gap:'12px' }}>
          <button onClick={onVolver} style={{ background:'rgba(255,255,255,0.1)', border:'none', color:'white', padding:'6px 14px', borderRadius:'10px', cursor:'pointer', fontSize:'13px' }}>← Menú</button>
          <BotonInstructivo moduloKey="despacho" oscuro={oscuro} />
          {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="despacho" oscuro={oscuro} />}
          <span style={{ color:'white', fontWeight:'700', fontSize:'16px' }}>📦 Despacho</span>
        </div>
        <div style={{ display:'flex', gap:'8px' }}>
          <CampanaNotificaciones oscuro={oscuro} modulo='Despacho'/>
          {esAdmin && <button onClick={() => setVista('nueva')} style={{ padding:'6px 14px', background:'#2A7FFF', color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontSize:'13px', fontWeight:'600' }}>+ Nuevo despacho</button>}
        </div>
      </div>

      {/* TABS */}
      <div style={{ display:'flex', borderBottom:`1px solid ${borde}`, background:cardBg, padding:'0 1.5rem' }}>
        {[['despachos','📦 Despachos'],['remitos','📄 Remitos'],['reporte','📊 Reporte']].map(([k,label]) => (
          <button key={k} onClick={() => setSeccion(k)}
            style={{ padding:'12px 18px', border:'none', borderBottom:seccion===k?`3px solid #2A7FFF`:'3px solid transparent', background:'none', cursor:'pointer', fontSize:'13px', fontWeight:seccion===k?'700':'500', color:seccion===k?'#2A7FFF':sub }}>
            {label}
          </button>
        ))}
      </div>

      <div style={{ padding:'1.2rem 1.5rem' }}>

        {/* KPIs */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(130px,1fr))', gap:'10px', marginBottom:'1.5rem' }}>
          {[['Total',resumen.total,'#2A7FFF'],['Este mes',resumen.mes,'#7B5BF2'],['FSC',resumen.fsc,'#22c55e'],['Clientes',resumen.clientes,'#f59e0b']].map(([lab,val,col]) => (
            <div key={lab} style={{ background:cardBg, borderRadius:'14px', padding:'1rem', border:`1px solid ${borde}`, textAlign:'center' }}>
              <p style={{ fontSize:'24px', fontWeight:'800', color:col, margin:0 }}>{val}</p>
              <p style={{ fontSize:'11px', color:sub, margin:'4px 0 0' }}>{lab}</p>
            </div>
          ))}
        </div>

        {/* TAB DESPACHOS */}
        {seccion === 'despachos' && (
          despachos.length === 0
            ? <div style={{ textAlign:'center', padding:'5rem 2rem' }}>
                <p style={{ fontSize:'48px' }}>📦</p>
                <p style={{ fontSize:'15px', color:texto, fontWeight:'600' }}>Sin despachos registrados</p>
                {esAdmin && <p style={{ fontSize:'13px', color:sub }}>Tocá "+ Nuevo despacho" para empezar</p>}
              </div>
            : [...despachos].reverse().map(d => (
                <div key={d.id} onClick={() => { setDetalle(d); setVista('detalle'); }}
                  style={{ background:cardBg, borderRadius:'14px', padding:'1.2rem 1.5rem', border:`1px solid ${borde}`, marginBottom:'10px', cursor:'pointer' }}
                  onMouseEnter={e => e.currentTarget.style.boxShadow='0 4px 20px rgba(42,127,255,0.15)'}
                  onMouseLeave={e => e.currentTarget.style.boxShadow='none'}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                    <div>
                      <span style={{ fontWeight:'700', color:'#2A7FFF', fontSize:'13px' }}>{d.codigo}</span>
                      {' '}<span style={{ fontSize:'13px', color:texto, fontWeight:'600' }}>{d.cliente}</span>
                      {d.fscMaterial && <span style={{ marginLeft:'6px', fontSize:'10px', color:'#15803d', background:'#dcfce7', padding:'1px 6px', borderRadius:'4px', fontWeight:'700' }}>🌿 FSC</span>}
                      <p style={{ fontSize:'12px', color:sub, margin:'4px 0 0' }}>{d.producto?.slice(0,50)} · {d.cantidad} {d.unidad}</p>
                    </div>
                    <div style={{ textAlign:'right' }}>
                      <p style={{ fontSize:'11px', fontWeight:'700', color:'#22c55e', margin:0 }}>✅ Despachado</p>
                      <p style={{ fontSize:'11px', color:sub, margin:'3px 0 0' }}>{d.fecha}</p>
                    </div>
                  </div>
                  <div style={{ marginTop:'6px', fontSize:'11px', color:oscuro?'#2A7FFF':'#9b8cc4' }}>
                    Remito: {d.remito} · OT: {d.otVinculada} · {d.creadoPor}
                  </div>
                </div>
              ))
        )}

        {/* TAB REMITOS */}
        {seccion === 'remitos' && (
          <>
            <div style={{ display:'flex', alignItems:'center', gap:'10px', marginBottom:'1rem' }}>
              <span style={{ fontSize:'12px', color:sub, fontWeight:'600' }}>Mes:</span>
              <input type='month' value={filtroMes} onChange={e => setFiltroMes(e.target.value)} style={{ ...inp, width:'auto', marginTop:0 }}/>
            </div>
            {despachosMes.length === 0
              ? <div style={{ textAlign:'center', padding:'3rem', color:sub }}><p style={{ fontSize:'32px' }}>📄</p><p>Sin remitos en {filtroMes}</p></div>
              : [...despachosMes].reverse().map(d => (
                  <div key={d.id} style={{ ...{ background:cardBg, borderRadius:'14px', padding:'1rem 1.5rem', border:`1px solid ${borde}`, marginBottom:'10px' }, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <div>
                      <span style={{ fontWeight:'700', color:'#2A7FFF', fontSize:'13px' }}>{d.remito}</span>
                      {' '}<span style={{ fontSize:'13px', color:texto }}>{d.cliente}</span>
                      <p style={{ fontSize:'11px', color:sub, margin:'3px 0 0' }}>{d.fecha} · OT: {d.otVinculada}</p>
                    </div>
                    <button onClick={() => exportarRemito(d)} style={{ padding:'7px 14px', background:'linear-gradient(135deg,#22c55e,#15803d)', border:'none', borderRadius:'8px', cursor:'pointer', color:'white', fontSize:'12px', fontWeight:'700' }}>
                      🖨️ Imprimir
                    </button>
                  </div>
                ))
            }
          </>
        )}

        {/* TAB REPORTE */}
        {seccion === 'reporte' && (
          <>
            <div style={{ display:'flex', alignItems:'center', gap:'10px', marginBottom:'1.5rem' }}>
              <span style={{ fontSize:'12px', color:sub }}>Mes:</span>
              <input type='month' value={filtroMes} onChange={e => setFiltroMes(e.target.value)} style={{ ...inp, width:'auto', marginTop:0 }}/>
            </div>
            <div style={{ ...card, background:oscuro?'#0a1f5c':'#eff6ff', border:`1px solid #2A7FFF30` }}>
              <h4 style={{ fontSize:'13px', fontWeight:'700', color:'#2A7FFF', marginBottom:'12px', textTransform:'uppercase' }}>Resumen — {filtroMes}</h4>
              {[
                ['Despachos del mes', despachosMes.length],
                ['Con certificación FSC', despachosMes.filter(d=>d.fscMaterial).length],
                ['Clientes distintos', [...new Set(despachosMes.map(d=>d.cliente).filter(Boolean))].length],
                ['OTs cerradas', despachosMes.length],
              ].map(([k,v]) => (
                <div key={k} style={{ display:'flex', justifyContent:'space-between', fontSize:'13px', padding:'6px 0', borderBottom:`0.5px solid ${borde}` }}>
                  <span style={{ color:sub }}>{k}</span>
                  <span style={{ color:texto, fontWeight:'700' }}>{v}</span>
                </div>
              ))}
            </div>
            {/* Top clientes del mes */}
            {despachosMes.length > 0 && (
              <div style={card}>
                <h4 style={{ fontSize:'13px', fontWeight:'700', color:texto, marginBottom:'12px', textTransform:'uppercase' }}>Despachos por cliente</h4>
                {Object.entries(
                  despachosMes.reduce((acc,d) => ({ ...acc, [d.cliente||'Sin cliente']: (acc[d.cliente||'Sin cliente']||0)+1 }), {})
                ).sort((a,b)=>b[1]-a[1]).map(([cli,cant]) => (
                  <div key={cli} style={{ display:'flex', justifyContent:'space-between', padding:'6px 0', borderBottom:`0.5px solid ${borde}`, fontSize:'13px' }}>
                    <span style={{ color:texto }}>{cli}</span>
                    <span style={{ fontWeight:'700', color:'#2A7FFF' }}>{cant} despacho{cant!==1?'s':''}</span>
                  </div>
                ))}
              </div>
            )}
          </>
        )}

      </div>
    </div>
  );
}
